// API Configuration for different environments
export const getApiBaseUrl = () => {
  // Check if we're in development or production
  if (process.env.NODE_ENV === 'development') {
    // Local development - use localhost backend
    return process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
  } else {
    // Production - use Railway backend
    return process.env.REACT_APP_API_BASE_URL || 'https://genaicoaching-production.up.railway.app';
  }
};

// Mattr SMS number (single source of truth for click-to-text links).
// NOTE: no `?body=`/`&body=` for the form flow — the welcome text already asks the
// user a question, so a prefilled body would become their (wrong) first answer.
export const MATTR_SMS_NUMBER = '+19179949725';
export const SMS_LINK = `sms:${MATTR_SMS_NUMBER}`;

// API endpoints
export const API_ENDPOINTS = {
  // Agent endpoints
  AGENT_CHAT: `${getApiBaseUrl()}/api/agent/chat`,
  
  // Workout endpoints
  WORKOUT_BY_ID: (id) => `${getApiBaseUrl()}/api/workout-id/${id}`,
  GENERATE_WORKOUT: `${getApiBaseUrl()}/api/generate-workout`,
  
  // Client endpoints
  CLIENTS: `${getApiBaseUrl()}/api/clients`,
  CLIENT_BY_ID: (id) => `${getApiBaseUrl()}/api/clients/${id}`,
  
  // Email endpoints
  SEND_EMAIL: `${getApiBaseUrl()}/api/send-email`,
  
  // SMS endpoints
  SEND_SMS: `${getApiBaseUrl()}/api/send-sms`,
  
  // Auth endpoints
  GOOGLE_AUTH: `${getApiBaseUrl()}/api/auth/google`,
  VERIFY_AUTH: `${getApiBaseUrl()}/api/auth/verify`,

  // Plan Chat endpoints (web-based plan modification)
  PLAN_CHAT_MESSAGE: `${getApiBaseUrl()}/api/plan-chat/message`,
  PLAN_CHAT_HISTORY: `${getApiBaseUrl()}/api/plan-chat/history`,
  PLAN_CHAT_VERSION: `${getApiBaseUrl()}/api/plan-chat/plan-version`,

  // Progress Dashboard
  PROGRESS_DASHBOARD: (clientId) => `${getApiBaseUrl()}/api/client/${clientId}/progress-dashboard`,
  CALENDAR: (clientId) => `${getApiBaseUrl()}/api/client/${clientId}/calendar`,
  COACH_MESSAGE: (clientId) => `${getApiBaseUrl()}/api/client/${clientId}/coach/message`,
  RACE_PLAN: (clientId) => `${getApiBaseUrl()}/api/client/${clientId}/race-plan`,
  WEIGHT: (clientId) => `${getApiBaseUrl()}/api/client/${clientId}/weight`,
  GEL_SIZE: (clientId) => `${getApiBaseUrl()}/api/client/${clientId}/gel-size`,
  FUEL_TARGET: (clientId) => `${getApiBaseUrl()}/api/client/${clientId}/fuel-target`,
  RACE_PLAN_EDIT: (clientId) => `${getApiBaseUrl()}/api/client/${clientId}/race-plan-edit`,
  RACE_CHECKLIST: (clientId) => `${getApiBaseUrl()}/api/client/${clientId}/race-checklist`,
  RACE_MILE_NOTES: (clientId) => `${getApiBaseUrl()}/api/client/${clientId}/race-mile-notes`,
  RACE_REFLECTION: (clientId) => `${getApiBaseUrl()}/api/client/${clientId}/race-reflection`,
  CALENDAR_ACTION: (clientId) => `${getApiBaseUrl()}/api/client/${clientId}/calendar/action`,
  CALENDAR_UNDO: (clientId) => `${getApiBaseUrl()}/api/client/${clientId}/calendar/undo`,
  COACH_THREAD: (clientId) => `${getApiBaseUrl()}/api/client/${clientId}/coach/thread?limit=6`,

  // Progress SMS Analytics
  PROGRESS_SMS_ANALYTICS: `${getApiBaseUrl()}/api/progress-sms-analytics?weeks_back=12`,

  // Garmin integration
  GARMIN_STATUS: (clientId) => `${getApiBaseUrl()}/api/garmin/status?client_id=${clientId}`,
  GARMIN_CONNECT: `${getApiBaseUrl()}/api/garmin/connect`,
  GARMIN_PUSH_WORKOUT: `${getApiBaseUrl()}/api/garmin/push-workout`,
  GARMIN_PUSH_WEEK: `${getApiBaseUrl()}/api/garmin/push-week`,
  GARMIN_PUSH_STRENGTH: `${getApiBaseUrl()}/api/garmin/push-strength`,
  GARMIN_DISCONNECT: `${getApiBaseUrl()}/api/garmin/disconnect`,

  // Watch API (Apple Watch)
  WATCH_WORKOUTS: (planId) => `${getApiBaseUrl()}/api/watch/workouts/${planId}`,
  WATCH_TODAY: (clientId) => `${getApiBaseUrl()}/api/watch/today/${clientId}`,
};

// Environment info
export const ENV_INFO = {
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  apiBaseUrl: getApiBaseUrl(),
  environment: process.env.REACT_APP_ENVIRONMENT || 'development',
};

// Log environment info in development
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Development Environment');
  console.log('🌐 API Base URL:', getApiBaseUrl());
  console.log('📱 Environment:', ENV_INFO.environment);
}
